<app-header-contract
  (close)="close()"
  (goNext)="goNext()"
  (goToStepper)="goToStepper()"
  (saveDraft)="saveDraft($event)"
  (openResume)="openResume($event)"
  (cancelContract)="cancelContract($event)"
  [activeNext]="activeNext"
  [activeNextCRM]="activeNextCRM"
  [hasContactoCRM]="hasContactoCRM"
  [noTypeSelected]="showTypeOptions"
  [showProgress]="!isPendingSign"
></app-header-contract>

<div class="new-contract-pymes" *ngIf="hasContactoCRM; else userSelection">
  <div class="loading-new-contract-pymes" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <div class="new-contract-pymes-type" *ngIf="showTypeOptions; else stepperTemplate">
    <app-type-selection-new-contract (contractType)="setContractType($event)"> </app-type-selection-new-contract>
  </div>

  <ng-template #stepperTemplate>
    <mat-tab-group
      class="new-contract-pymes__stepper"
      [selectedIndex]="tabIndex.value"
      (selectedTabChange)="tabChange($event)"
    >
      <mat-tab
        [aria-labelledby]="tabIndex.value >= 0 ? 'active' : null"
        [disabled]="tabIndex.value === 0 || tabIndex.value === 4"
      >
      <app-risk-analysis-pymes
        [hidden]="tabIndex.value !== 0"
        (formValid)="formValidChange($event)"
        (draftEnable)="activateDraft($event)"
        (isLoading)="setLoading($event)"
      ></app-risk-analysis-pymes>
      </mat-tab>
      <mat-tab
        [aria-labelledby]="tabIndex.value > 0 ? 'active' : null"
        [disabled]="tabIndex.value <= 1 || tabIndex.value === 4"
      >
        <app-business-name-pymes
          *ngIf="tabIndex.value === 1"
          (formValid)="formValidChange($event)"
        ></app-business-name-pymes>
      </mat-tab>
      <mat-tab
        [aria-labelledby]="tabIndex.value > 1 ? 'active' : null"
        [disabled]="tabIndex.value <= 2 || tabIndex.value === 4"
      >
        <app-installation-data-pymes
          *ngIf="tabIndex.value === 2"
          (formValid)="formValidChange($event)"
        ></app-installation-data-pymes>
      </mat-tab>
      <mat-tab
        [aria-labelledby]="tabIndex.value > 2 ? 'active' : null"
        [disabled]="tabIndex.value <= 3 || tabIndex.value === 4"
      >
        <app-payments-data (formValid)="formValidChange($event)" *ngIf="tabIndex.value === 3"></app-payments-data>
      </mat-tab>
      <mat-tab [aria-labelledby]="tabIndex.value > 3 ? 'active' : null" [disabled]="true">
        <app-contract-signing
          *ngIf="tabIndex.value === 4"
          [hasSepaFile]="hasSepaFile"
          [hasContractFile]="hasContractFile"
          [finishCreateFiles]="asyncContractCreated"
          (formValid)="formValidChange($event)"
          (isLoading)="setLoading($event)"
        ></app-contract-signing>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</div>
<ng-template #userSelection>
  <div class="new-contract-pymes-user">
    <app-user-selection-new-contract [user]="userData" (contactoCRM)="setContactoCRM($event)">
    </app-user-selection-new-contract>
  </div>
</ng-template>
